import { useEffect } from "react";
import "@fontsource/mulish";
import Homepage from "./pages/index";
import Header from "./components/Header";
import { HelmetProvider } from "react-helmet-async";
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import Thankyou from "./pages/thankyou";
import { pageViewEvent } from "./services/adobeDataLayer";

function App() {
  //Trigger AA Page View Event
  useEffect(() => {
    pageViewEvent("landing page");
  }, []);
  return (
    <HelmetProvider>
      <Router basename={window.location.pathname}>
        <Header path="./dist/img/icici_logo.webp" />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/thankyou" element={<Thankyou />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
